module.exports = __webpack_public_path__ + "img/fjgl.fb1ad14f.svg";